import { render, staticRenderFns } from "./TournamentRanking.vue?vue&type=template&id=2f9de9ac&scoped=true"
import script from "./TournamentRanking.vue?vue&type=script&lang=js"
export * from "./TournamentRanking.vue?vue&type=script&lang=js"
import style0 from "./TournamentRanking.vue?vue&type=style&index=0&id=2f9de9ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9de9ac",
  null
  
)

export default component.exports